"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const theme_1 = require("../font/theme");
const light_1 = require("../color/theme/light");
exports.theme = {
    light: light_1.theme.light,
    font: theme_1.theme,
    color: light_1.theme,
};
